__webpack_require__.p = "https://assets.canny.io/e3f76d92270b27d3ea4a581b77a1a193cd0b93d2/";